import type { NotificationType } from '../api/client';
import { websiteUrl } from './websiteUrl';

/**
 * Fixed per-type destination the "View" action button jumps to, resolved
 * from `type` alone — never from `related_type`/`related_id`, per the PO's
 * v2 design decision (the frontend owns this map; the backend's related_*
 * fields exist only for whatever finer-grained context a future type
 * wants). A type with no entry here has no related page: NotificationActions
 * then shows only the "Contact support" button.
 */
const ROUTES: Partial<Record<NotificationType, string>> = {
  key_suspended_abuse: '/keys',
  low_balance: '/topup',
  free_quota_fallback_billing: '/topup',
  topup_requested: '/topup',
  added_to_org: '/dashboard',
};

export function notificationRoute(type: NotificationType): string | undefined {
  return ROUTES[type];
}

/** `${websiteUrl()}contact`, or null when PUBLIC_WEBSITE_HOST isn't set (see websiteUrl's own note). */
export function contactSupportUrl(): string | null {
  const base = websiteUrl();
  return base ? `${base}contact` : null;
}
